import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { forwardRef } from "react";
import Close from "@engineering/icons/close";
import { CloseButton } from "./Popover.styles";
export var ContentWrapper = /*#__PURE__*/ forwardRef(function(param, ref) {
    var children = param.children, onClose = param.onClose;
    return /*#__PURE__*/ _jsxs("div", {
        ref: ref,
        children: [
            onClose && /*#__PURE__*/ _jsx(CloseButton, {
                icon: Close,
                onClick: onClose
            }),
            children
        ]
    });
});
